import { render, staticRenderFns } from "./VClubCTA.vue?vue&type=template&id=93a96f86&scoped=true&"
import script from "./VClubCTA.vue?vue&type=script&lang=js&"
export * from "./VClubCTA.vue?vue&type=script&lang=js&"
import style0 from "./VClubCTA.vue?vue&type=style&index=0&id=93a96f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a96f86",
  null
  
)

export default component.exports